import { createSelector } from 'reselect'

import { selectState } from './selectState'

export const selectJBPSettingsStatus = createSelector([selectState], (state) => state.status)
